import React, { useMemo, ReactElement } from 'react'
import { LoyaltyPointsEarningConfiguration } from './CartReviewTile'
import LoyaltyPointsEarnWithBreakdownModal from 'loyalty/components/Earn/LoyaltyPointsEarnWithBreakdownModal'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import MerchandiseLowStockMessage from 'components/Merchandise/MerchandiseLowStockMessage'
import { getMerchandiseVariantOptionText } from 'components/Merchandise/merchandiseUtils'
import LabelGroup from 'LuxKit/Label/LabelGroup'

interface Props {
  brand: string
  title: string
  variant?: App.MerchandiseOfferVariant
  loyaltyPointsEarningConfiguration?: LoyaltyPointsEarningConfiguration
  label?: ReactElement
}

function MerchandiseCartReviewTileContent(props: Props) {
  const { brand, title, variant, loyaltyPointsEarningConfiguration, label } = props
  const variantDetails = useMemo(() => {
    if (variant) {
      return getMerchandiseVariantOptionText(variant)
    }
  }, [variant])

  return <VerticalSpacer gap={12}>
    {variant && <MerchandiseLowStockMessage variants={[variant]} />}
    {label && <LabelGroup>
      {label}
    </LabelGroup>}
    <VerticalSpacer gap={2}>
      <BodyText variant="medium" colour="neutral-two">{brand}</BodyText>
      <Heading variant="heading6">{title}</Heading>
      {variantDetails && <BodyText variant="medium" colour="neutral-two">{variantDetails}</BodyText>}
    </VerticalSpacer>
    {loyaltyPointsEarningConfiguration &&
      <LoyaltyPointsEarnWithBreakdownModal
        calculationRequests={loyaltyPointsEarningConfiguration.calculationRequests}
        calculationType={loyaltyPointsEarningConfiguration.calculationType}
        hideStatusCredits={loyaltyPointsEarningConfiguration.hideStatusCredits}
      />}
  </VerticalSpacer>
}

export default React.memo(MerchandiseCartReviewTileContent)
